import { render } from "./DialogBox.vue?vue&type=template&id=7af6f8e6&scoped=true&lang=pug"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import "./DialogBox.vue?vue&type=style&index=0&id=7af6f8e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af6f8e6"]])

export default __exports__